
import { useEffect, useState } from "react";
import getThisUser from "../components/helpers/getThisUser";
import LoadingTakeover from "../components/buffers/LoadingTakeover";


const withThisUser = (WrappedContent) => {

    return function WithThisUserComponent(props) {
        const [thisUserData, setThisUserData] = useState(null);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);

        useEffect(() => {
            getThisUser(setThisUserData);
        }, [])

        useEffect(() => {
            if (thisUserData) {
                setLoading(false);
            }
        }
        ,[thisUserData]);

        if (!thisUserData) return <LoadingTakeover />
        if (error) return <div>Error loading user data</div>;
            
        return <WrappedContent {...props} thisUserData={thisUserData}/>;
    };
};

export default withThisUser;